import { Box, ChevronDown, ChevronRight, Heading, Image, LayoutPanelTop, Link2, Type } from "lucide-react";
import type { EditorObject } from "@prototypical/editor-contract";

export function ObjectBranch({
  object, selectedPath, expanded, onToggle, onSelect,
}: {
  object: EditorObject;
  selectedPath: string | null;
  expanded: Set<string>;
  onToggle: (id: string) => void;
  onSelect: (object: EditorObject) => void;
}) {
  const children = object.children ?? [];
  const active = object.fieldPath === selectedPath || object.id === selectedPath;
  const containsSelection = (node: EditorObject): boolean =>
    node.fieldPath === selectedPath || node.id === selectedPath || (node.children ?? []).some(containsSelection);
  const open = expanded.has(object.id) || children.some(containsSelection);
  const Icon = object.kind === "section" ? LayoutPanelTop
    : object.kind === "image" ? Image
      : object.kind === "link" ? Link2
        : object.kind === "text" || object.kind === "richtext" ? Type
          : /^h[1-6]$/.test(object.kind) ? Heading : Box;
  return (
    <div className="object-branch">
      <button
        className={`object-row${active ? " active" : ""}`}
        aria-label={object.label}
        title={object.label}
        onClick={() => { if (children.length) onToggle(object.id); onSelect(object); }}
        aria-expanded={children.length ? open : undefined}
      >
        {children.length ? open ? <ChevronDown size={13} /> : <ChevronRight size={13} /> : <span className="object-indent" />}
        <span className={`object-kind ${object.kind}`}><Icon size={12} /></span>
        <span>{object.label}</span>
      </button>
      {open && children.length > 0 && <div className="object-children">{children.map((child, index) => <ObjectBranch key={`${object.id}/${child.id}/${index}`} object={child} selectedPath={selectedPath} expanded={expanded} onToggle={onToggle} onSelect={onSelect} />)}</div>}
    </div>
  );
}
